import { memo } from 'react';
import { cn } from '@page/ui';

import { Loader } from '../../designSystem/Loader';

export interface SectionLoadingPlaceholderProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const SectionLoadingPlaceholderBase = ({
  title = 'Loading...',
  description,
  className,
}: SectionLoadingPlaceholderProps) => {
  return (
    <div className={cn('px-16 py-14 flex flex-col items-center justify-center h-full', className)}>
      <Loader className="size-20" />

      <div className="text-text-primary font-heading-3xl font-semibold mt-8 dark:text-white text-center">{title}</div>

      {description && (
        <div className="text-text-secondary font-heading-l mt-4 dark:text-white/80 text-center">{description}</div>
      )}
    </div>
  );
};

export const SectionLoadingPlaceholder = memo(SectionLoadingPlaceholderBase);
